import React, { Component } from 'react';
import {Routes,Route} from "react-router-dom";
import Main from "./main";
import Privacy from "./privacy";

class App extends Component {
  render() {
    return (
      <>
      <Routes>
      <Route path="" element={<Main/>}/>
      <Route path="privacy" element={<Privacy/>}/>
      </Routes>
    
      </>
     
    )
  }
}

export default App;


